module.exports = __webpack_public_path__ + "image@2x.png?834bebbb7188be07e1a0286241b71a0b";